module.exports = __webpack_public_path__ + "img/Domain_EHR.249dad12.png";